import { Fragment, useEffect, useState } from "react";
import { Card, CardHeader, Col, Row, CardBody, Input, Button, Table, Modal, ModalBody, InputGroup, InputGroupAddon, InputGroupText, ModalHeader } from "reactstrap";
import { translate } from "react-switch-lang";
import { useHttpClient } from "../../../security/hooks/axiosProvider";
import { toast } from "react-toastify";
import SweetAlert from "sweetalert2";
import { VideoTypeDto } from "../../../models/videoTypeDto";
import styles from "./videoType.module.scss";
import AddSetting from "../add-setting/addSetting";
import { TypeSetting } from "../../../models/typeSetting";

function TypeVideo(props: any) {
  toast.configure();
  const httpClient = useHttpClient(true);
  const [videoType, setVideoType] = useState<VideoTypeDto>(new VideoTypeDto());
  const [openModal, setOpenModal] = useState<boolean>(false);
  const [listVideoType, setListVideoType] = useState<VideoTypeDto[]>([]);
  const [listFiltredVidoeType, setListFiltredVideoType] = useState<VideoTypeDto[]>([]);
  const [isOncreate, setIsOncreate] = useState<boolean>(true);

  const toggle = (data: VideoTypeDto) => {
    setOpenModal(!openModal);
    setVideoType(data);
  };

  useEffect(() => {
    httpClient.current?.get("/video_type").then(response => {
      setListVideoType(response.data);
      setListFiltredVideoType(response.data);
    });
  }, [httpClient]);

  const handleDeleteVideoType = (videoTypeId: any) => {
    SweetAlert.fire({
      title: props.t("video_type.message_confirmation_delete_video_type"),
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: String(props.t("button_delete")),
      cancelButtonText: String(props.t("button_cancel")),
      reverseButtons: true,
    }).then(result => {
      if (result.value) {
        httpClient.current?.delete("/video_type/" + videoTypeId).then(response => {
          if (response.data) {
            toast.success(String(props.t("message_toastr_delete")), {
              position: toast.POSITION.TOP_RIGHT,
              autoClose: 5000,
            });
            handleGetVideoType();
          } else {
            toast.error(String(props.t("video_type.message_toastr_cannot_delete_video_type")), {
              position: toast.POSITION.TOP_RIGHT,
              autoClose: 5000,
            });
          }
        });
      }
    });
  };

  const handleGetVideoType = () => {
    httpClient.current?.get("/video_type").then(response => {
      setListFiltredVideoType(response.data);
      setListVideoType(response.data);
    });
  };

  const handleClickOnUpdate = (data: VideoTypeDto, index: number) => {
    toggle(data);
    setIsOncreate(false);
  };

  const handleSearch = (value: string) => {
    setListFiltredVideoType(
      listVideoType.filter(type => type.titleFrancais.toLocaleLowerCase().includes(value.toLocaleLowerCase()) || type.titleAnglais.toLocaleLowerCase().includes(value.toLocaleLowerCase())),
    );
  };

  return (
    <Fragment>
      <Card>
        <CardHeader className={styles["parametrage-card-header"]}>
          <Row>
            <Col md={12}>
              <div className={styles["parametrage-card-header-input"]}>
                <div className={styles["parametrage-card-inputs"]}>
                  <InputGroup className={styles["categories-search-input-group"]}>
                    <Input onChange={e => handleSearch(e.target.value)} type="search" placeholder={String(props.t("filters.input_placeholder_search"))} />
                    <InputGroupAddon addonType="append">
                      <InputGroupText className={styles["categories-search-input-group-text"]}>
                        <i className={"fa fa-search " + styles["categories-search-input-group-icon"]} />
                      </InputGroupText>
                    </InputGroupAddon>
                  </InputGroup>
                </div>
                <Button
                  outline
                  color="success"
                  className={styles["categories-add-btn"]}
                  onClick={() => {
                    setIsOncreate(true);
                    toggle(new VideoTypeDto());
                  }}
                >
                  {props.t("video_type.button_add_video_type")}
                </Button>
              </div>
            </Col>
          </Row>
        </CardHeader>

        <CardBody className={styles["parametrage-card-body"]}>
          {listVideoType.length === 0 ? (
            <div className="text-center">
              <div className={styles["no-data"]}>{props.t("video_type.message_no_video_type_title")} </div>
              <div className={styles["no-data"]}>{props.t("video_type.message_no_video_type_subtitle")}</div>
            </div>
          ) : (
            <Fragment>
              {
                <Table className={styles["parametrage-card-body"]}>
                  <thead>
                    <tr>
                      <th className={styles["document-table-nom"]} scope="col">
                        <span onClick={() => ""} className={styles["pointer"]}>
                          <i className={""}></i> {props.t("param_table_header.label_image")}
                        </span>
                      </th>
                      <th className={styles["document-table-thematique"]} scope="col">
                        {props.t("param_table_header.label_image")}
                      </th>
                      <th className={styles["document-table-type"]} scope="col">
                        <span onClick={() => ""} className={styles["pointer"]}>
                          <i className={""}></i> {props.t("param_table_header.label_title_en")}
                        </span>
                      </th>

                      <th className={styles["document-table-actions"]} scope="col">
                        {props.t("param_table_header.actions")}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {listFiltredVidoeType.map((data: VideoTypeDto, index: number) => (
                      <tr key={data.videoTypeId}>
                        <td>
                          <img className={styles["parametrage-card-image"]} src={data.urlImage + "/preview"} alt="" />
                        </td>
                        <td className="align-middle">{data.titleFrancais}</td>
                        <td className="align-middle">{data.titleAnglais}</td>

                        <td className={`${styles["document-table-actions-icons"]} align-middle`}>
                          <div>
                            <i className={`${styles["parametrage-actions__btn-update"]} fa fa-edit`} onClick={() => handleClickOnUpdate(data, index)} />
                            <i className={`${styles["parametrage-actions__btn-delete"]} fa fa-trash-o`} onClick={() => handleDeleteVideoType(data.videoTypeId)} />
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              }
            </Fragment>
          )}
        </CardBody>
      </Card>
      <Modal isOpen={openModal} toggle={() => toggle(new VideoTypeDto())} size="lg">
        <ModalHeader toggle={() => toggle(new VideoTypeDto())}>{isOncreate ? props.t("video_type.title_create_video_type") : props.t("video_type.title_update_video_type")}</ModalHeader>
        <ModalBody>
          <AddSetting toggle={toggle} handleGet={handleGetVideoType} type={TypeSetting.VIDEO} settingModal={videoType}></AddSetting>
        </ModalBody>
      </Modal>
    </Fragment>
  );
}

export default translate(TypeVideo);
